import React from 'react';
import { TableRow, TableCell } from 'semantic-ui-react';

import { WorksheetPageIndex } from 'services/worksheet/types';
import {
    FertilizerProductId,
    FertilizerProductPerUnitType
} from 'services/fertilizerEvents/types';
import ProductNameTableCell from './components/ProductNameTableCell';
import ProductOrderTableCell from './components/ProductOrderTableCell';
import ProductReEntryPeriodDaysTableCell from './components/ProductReEntryPeriodDaysTableCell';
import ProductWitholdingPeriodDaysTableCell from './components/ProductWitholdingPeriodDaysTableCell';
import ProductRatePerAreaTableCell from './components/ProductRatePerAreaTableCell';
import ProductNPKTableCell from './components/ProductNPKTableCell';
import ProductSMgCaTableCell from './components/ProductSMgCaTableCell';
import ProductTotalTableCell from './components/ProductTotalTableCell';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: FertilizerProductId;
    perUnitType: FertilizerProductPerUnitType;
}

type Props = OwnProps;

export default function FertilizerPrintWorksheetProductsTableRow(
    props: Props
): React.ReactElement {
    const { productId, pageIndex, perUnitType } = props;

    return (
        <TableRow>
            <ProductNameTableCell productId={productId} pageIndex={pageIndex} />
            <ProductRatePerAreaTableCell
                productId={productId}
                pageIndex={pageIndex}
                perUnitType={perUnitType}
            />
            <ProductTotalTableCell
                productId={productId}
                pageIndex={pageIndex}
                perUnitType={perUnitType}
            />
            <ProductNPKTableCell productId={productId} pageIndex={pageIndex} />
            <ProductSMgCaTableCell
                productId={productId}
                pageIndex={pageIndex}
            />
            <TableCell>{}</TableCell>
            <TableCell>{}</TableCell>
            <ProductOrderTableCell
                productId={productId}
                pageIndex={pageIndex}
            />
            <ProductReEntryPeriodDaysTableCell
                productId={productId}
                pageIndex={pageIndex}
            />
            <ProductWitholdingPeriodDaysTableCell
                productId={productId}
                pageIndex={pageIndex}
            />
        </TableRow>
    );
}
